import React, { Component } from "react";
import { connect } from "react-redux";

const AuthHOC = WrappedComponent => {
	class Auth extends Component {
		isLogged = () => {
			const { token } = this.props.authentication;
			const { permissions } = this.props.authorization
			
			if (token && permissions.length) {
				return true
			} else {
				return false
			}
		};

		logout = () => {
			localStorage.clear();
			this.props.cleanAuthorization();
			this.props.logout();
		};

		componentDidMount = () => {
			if (this.isLogged()) {
				let gotPermissions =
					this.props.authorization && this.props.authorization.length;

				if (gotPermissions) return;

				// test if the redux updated the props
				if (!gotPermissions) {

					this.setState({
						completedAuth: true
					});
				}
			} else {
				this.logout();
			}
		};

		getPermissions = () => {
			// if redux lost permissions, get them again
			return this.props.authorization;
		};

		render() {
			return (
				<WrappedComponent
					isLogged={this.isLogged}
					logout={this.logout}
					getPermissions={this.getPermissions()}
				></WrappedComponent>
			);
		}
	}

	const mapStateToProps = state => {
		return {
			authorization: state.authorization,
			authentication: state.authentication
		};
	};

	const mapDispatchToProps = dispatch => {
		return {
			logout: () =>
				dispatch({
					type: "LOGOUT"
				}),
			cleanAuthorization: () =>
				dispatch({
					type: "CLEAN_AUTHORIZATION"
				})
		};
	};


	// return Auth;
	return connect(
		mapStateToProps,
		mapDispatchToProps
	)(Auth);
};

export default AuthHOC;
